import { selectExperience, useExperienceStore } from '@/store/experienceStore';

/** Store seam for ap-layer chrome — components/ap may not import stores directly. */
export const useCurrentExperience = () => useExperienceStore(selectExperience);
